import { render, staticRenderFns } from "./DownloadAllo.vue?vue&type=template&id=62e646e0&scoped=true&"
import script from "./DownloadAllo.vue?vue&type=script&lang=ts&"
export * from "./DownloadAllo.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadAllo.vue?vue&type=style&index=0&id=62e646e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e646e0",
  null
  
)

export default component.exports